module.exports = __webpack_public_path__ + "static/media/Ethpar_Logo.19363c6a.png";